module.exports = __webpack_public_path__ + "static/media/circle7.54dac080.svg";